const getters = {
  sidebarCollapse: state => {
    return state.appStore.sidebarCollapse
  },
  tagsContainer: state => {
    return state.appStore.tagsContainer
  },
  isCheckRole: state => state.user.isCheckRole,
  permission_routes: state => state.permission.routes,
  token: state => state.permission.token,
  role: state => state.user.sapRoles,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  userInfo: state => state.user.userInfo,
  customerInfo: state => state.user.customerInfo,
  mdmManager: state => state.user.mdmManager,
  perBtnKeys: state => Object.keys(state.permission.buttonPer)
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js